
import objectAssign from 'object-assign'
import mentionsMixin from './mentions-mixin'
import SirTrevor from "sir-trevor";

export default (function(){

  return SirTrevor.Blocks.Text.extend(objectAssign({}, mentionsMixin, {

    scribeOptions: {
      tags: {
        p: true,
        a: true,
        b: true,
        span: true,
        input: true
      }
    },

    loadData: function(data) {
      this.initializeMentions();
      let text = this.insertMentions(data.text);

      this.setTextBlockHTML(text);
    },

    onBlockRender: function() {
      this.focus();
      this.toggleEmptyClass();

      this.initializeMentions();
      this.getTextBlock()[0].addEventListener('keypress', this.detectMentionStart.bind(this));
      this.getTextBlock()[0].addEventListener('keyup', this.findMentions.bind(this));
      this.getTextBlock()[0].addEventListener('keydown', e => {
        this.onMentionKeyDown(e);
        // Bug in chrome that stops mentions from being deleted if last element.
        if (e.keyCode === 8) {
          let editor = this.getTextBlock()[0];
          if (editor.childNodes.length > 0) {
            let lastChild = editor.childNodes[0].lastChild;
            if (lastChild && lastChild.classList && lastChild.classList.contains('st-mention')) {
              lastChild.parentNode.removeChild(lastChild);
            }
          }
        }
      })

      this._scribe.on('content-changed', () => {
        setTimeout(() => this.mediator.trigger("block:updated"), 1);
      });

      // IE 11 paste.
      if(Object.hasOwnProperty.call(window, "ActiveXObject") && !window.ActiveXObject) {
        this._scribe.el.addEventListener('paste', () => {
          setTimeout(() => {

            var fakeContent = document.createElement('div');
            fakeContent.innerHTML = this._scribe.getContent();

            if (fakeContent.childNodes.length > 1) {

              var nodes = Array.from(fakeContent.childNodes);
              this._scribe.setContent( nodes.shift().innerHTML );
              nodes.reverse().forEach((node) => {
                var data = {
                  format: 'html',
                  text: node.innerHTML
                };
                this.mediator.trigger("block:create", 'Text', data, this.el);
              });
              this._scribe.el.focus();
            }

          }, 1);
        });
      }
    },

    _serializeData: function() {
      let text = this.getTextBlockHTML();
      return {
        text: this.getTextContentWithMentions(text),
        format: 'html'
      }
    }
  }))
})();
